<title>Autoverkoop Partner - Bod afwijzen</title>

<!-- Page Content -->
<div class="container">
  <div class="card border-0 shadow my-5">
    <div class="card-body p-5">
      <img class="img-fluid header-img" src="/assets/images/avp-logo.png">
      <hr>

        @if (showFeedback == true) {
          <div class="alert alert-primary" role="alert">
            Bedankt voor je feedback, de aanvraag is geannuleerd.
          </div>
        }

        @if (showError == true) {
          <div class="alert alert-danger" role="alert">
            Er is een fout opgetreden, probeer het later opnieuw.
          </div>
        }

        <form [formGroup]="form" class="needs-validation">
          @if (showFeedback == false) {
            <div>
              <h1 class="font-weight-light">Bod afwijzen</h1>
              <p class="lead">Wat jammer, weet je zeker dat je ons bod wil afwijzen? <br> <br>
                Mogen we je nog wel vragen waarom je ons bod afgewezen hebt?
              Daar leren we namelijk van.</p>
              <div class="row">
                <div class="form-group col">
                  <select (change)="updateSelectReason()" formControlName="selectReason" class="form-select"  [ngClass]="{ 'is-invalid': submitted && f.selectReason.errors }">
                    <option value="" selected>Selecteer een reden...</option>
                    @for (reason of declineReasons; track reason) {
                      <option [value]="reason.type">{{reason.value}}
                      </option>
                    }
                  </select>
                  @if (submitted && f.selectReason.errors) {
                    <div class="invalid-feedback">
                      @if (f.reason.errors.required) {
                        <div>Selecteer een reden</div>
                      }
                    </div>
                  }
                </div>
              </div>
              @if (selectedReason) {
                <div>
                  @if (selectedReason.type == 'other') {
                    <div class="row">
                      <div class="form-group col">
                        <label>Wat is de reden?</label>
                        <textarea formControlName="reason" class="form-control" rows="5"
                        [ngClass]="{ 'is-invalid': submitted && f.reason.errors }"></textarea>
                        @if (submitted && f.reason.errors) {
                          <div class="invalid-feedback">
                            @if (f.reason.errors.required) {
                              <div>Reden is een verplicht veld</div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (selectedReason.type == 'higher_bid') {
                    <div class="row">
                      <div class="form-group col-md-4">
                        <label>Bedrag (Euro)</label>
                        <input type="text" formControlName="amount" class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.amount.errors }">
                        @if (submitted && f.amount.errors) {
                          <div class="invalid-feedback">
                            @if (f.amount.errors.required) {
                              <div>Reden is een verplicht veld</div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              <button (click)="decline()" type="button" class="btn btn-primary" type="submit">Bod
              afwijzen</button>
            </div>
          }
        </form>

        <div style="height: 1000px"></div>
      </div>
    </div>